import * as React from 'react'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'
import {AISolutionDetailLayout} from '@components/ai'

const Meta = dynamic(() => import('@components/Meta'))

export default function Machinery() {
  return (
    <React.Fragment>
      <Meta title={`Machinery | Datawow – ${t('layout.title')}`} />

      <section className='AISolutionDetail__introduction'>
        <div className='container'>
          <div className='grid grid--max-left'>
            <h1>
              <small>ตัวอย่าง AI Use Case ทางด้าน</small>
              Machinery
            </h1>
            <p>
              ปัจจุบัน AI ได้เข้ามามีบทบาทอย่างมากในอุตสาหกรรมการผลิตเครื่องจักร
              โดยเทรนด์การใช้ AI ในกระบวนการผลิตนั้นประกอบไปด้วยการทำ Predictive
              Maintenance กระบวนการ Quality Inspection และ การทำ Simulation และ
              Optimization
            </p>
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__feature-img'>
        <img
          src='/images/ai/machinery/feature1.jpg'
          srcSet='/images/ai/machinery/feature1@2x.jpg 2x'
          alt='Machinery'
        />
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--light'>
        <div className='container'>
          <div className='grid grid--max-left'>
            <div>
              <h2>
                Predictive<span>Maintenance</span>
              </h2>
              <img
                src='/images/ai/machinery/feature2.jpg'
                srcSet='/images/ai/machinery/feature2@2x.jpg 2x'
                alt='Machinery'
                loading='lazy'
                className='lg'
              />
            </div>

            <div>
              <p>
                โรงงานผลิตจะต้องมีการหยุดดำเนินการ หรือที่เรียกว่า Downtime
                สำหรับการซ่อมบำรุงเครื่องจักร
                ซึ่งอาจเกิดขึ้นตามกำหนดการที่วางเอาไว้ล่วงหน้า หรือ
                อาจเกิดขึ้นอย่างฉุกเฉินเมื่อเครื่องจักรมีปัญหาและไม่สามารถใช้งานได้ตามปกติ
                การที่เครื่องจักรต้องหยุดทำงานอย่างฉุกเฉิน หรือ Unplanned
                Downtime
                นั้นก่อให้เกิดการหยุดชะงักของกระบวนการผลิตอันนำไปสู่ผลผลิตที่ต่ำกว่าที่ควรจะเป็น
                รวมถึงเพิ่มค่าใช้จ่ายอีกด้วย{' '}
              </p>
              <p>
                เพื่อป้องกัน Unplanned Downtime จึงมีการนำ AI เข้ามาใช้ในการทำ
                Predictive Maintenance โดยการใช้ Machine Learning
                มาทำความเข้าใจรูปแบบของเครื่องจักรที่กำลังจะมีปัญหาเพื่อที่จะคาดการณ์ล่วงหน้าหากต้องมีการหยุดการทำงานของเครื่องจักรเพื่อดำเนินการซ่อมบำรุง
                ด้วยเทคนิคการทำ Predictive Maintenance
                นี้จะทำให้โรงงานสามารถวางแผนการผลิตและจัดสรรทรัพยากรได้อย่างมีประสิทธิภาพ
                เพื่อให้ได้ผลการผลิตสูงสุด
              </p>
            </div>
          </div>

          <img
            src='/images/ai/machinery/feature2.jpg'
            srcSet='/images/ai/machinery/feature2@2x.jpg 2x'
            alt='Machinery'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>

      <section className='AISolutionDetail__card'>
        <div className='container'>
          <h2>Quality Inspection</h2>

          <div className='AISolutionDetail__card__body'>
            <div>
              <p>
                ในกระบวนการผลิตโดยปกติแล้วจะต้องมีชิ้นงานที่บกพร่องชำรุด
                หรือที่เรียกว่า Defect ซึ่งโรงงานจะต้องมีการจัดขั้นตอนการทำ
                Quality Inspection
                เพื่อที่จะวัดคุณภาพผลผลิตและทำการคัดแยกชิ้นงานที่ไม่ได้คุณภาพออกมา
                ซึ่งโดยทั่วไปนั้นการทำ Quality Inspection
                ในลักษณะนี้จะต้องใช้มนุษย์ในการคัดแยก
                ซึ่งมีความเสี่ยงในการเกิดความผิดพลาด และมีต้นทุนที่ค่อนข้างสูง
              </p>
              <p>
                นำไปสู่การใช้ AI ในการทำ Quality Inspection ด้วยเทคนิคทาง
                Computer Vision
                เพื่อวิเคราะห์ลักษณะของชิ้นงานว่ามีคุณภาพเป็นไปตามมาตรฐานหรือไม่
                มีจุดที่บกพร่องที่ต้องคัดแยกชิ้นงานออกไปหรือไม่
                ซึ่งด้วยเทคโนโลยีในปัจจุบัน AI มีความแม่นยำ
                และความสม่ำเสมอในการวิเคราะห์ที่สูงกว่ามนุษย์มาก
                ทำให้โรงงานสามารถควบคุมคุณภาพของผลผลิตให้อยู่ในมาตรฐานการผลิตได้
              </p>
            </div>

            <img
              src='/images/ai/machinery/feature3.jpg'
              srcSet='/images/ai/machinery/feature3@2x.jpg 2x'
              loading='lazy'
              alt='Quality Inspection'
            />
          </div>
        </div>
      </section>

      <section className='AISolutionDetail__section AISolutionDetail__section--dark'>
        <div className='container'>
          <h2>Simulation and Optimization</h2>

          <div className='grid grid--max-left'>
            <img
              src='/images/ai/machinery/feature4.jpg'
              srcSet='/images/ai/machinery/feature4@2x.jpg 2x'
              alt='Simulation and Optimization'
              loading='lazy'
              className='lg'
            />
            <div>
              <p>
                ก่อนที่จะเริ่มดำเนินการผลิต
                โรงงานจะต้องมีการทำแผนการผลิตล่วงหน้าเพื่อจัดสรรเครื่องจักร
                วัตถุดิบ เครื่องมือ ไปจนถึงบุคลากรในกระบวนการผลิต{' '}
                เพื่อให้การผลิตสามารถดำเนินการได้อย่างไม่ติดขัด ซึ่ง AI
                สามารถนำแผนการผลิตนั้นมาใช้ในการจำลองการผลิตได้ว่าในแต่ละช่วงเวลา
                จะมีการใช้วัตถุดิบ และเครื่องมือไปเท่าไหร่ได้ผลผลิตเท่าไหร่
                การจัดสรรบุคลากรเพียงพอหรือไม่
                กำหนดการผลิตของเครื่องจักรมีข้อผิดพลาดตรงไหนหรือไม่
              </p>
              <p>
                ยิ่งไปกว่านั้น AI
                ยังสามารถช่วยในการทำแผนการผลิตอัตโนมัติเพื่อจัดสรรทรัพยากรให้กับโรงงานได้อีกด้วย
                เพื่อที่จะได้ผลผลิตสูงที่สุด
                ภายใต้เงื่อนไขที่ทำให้การดำเนินการผลิตสามารถดำเนินไปได้อย่างต่อเนื่อง
                โดยไม่มีข้อผิดพลาด และยังสามารถปรับเปลี่ยนได้อย่างทันท่วงที
                เมื่อมีสถานการณ์ที่ทำให้แผนการผลิตจะต้องมีการเปลี่ยนแปลงอย่างกะทันหัน
              </p>
            </div>
          </div>

          <img
            src='/images/ai/machinery/feature4.jpg'
            srcSet='/images/ai/machinery/feature4@2x.jpg 2x'
            alt='Simulation and Optimization'
            loading='lazy'
            className='sm'
          />
        </div>
      </section>
    </React.Fragment>
  )
}

Machinery.getLayout = function getLayout(page: React.ReactElement) {
  return <AISolutionDetailLayout>{page}</AISolutionDetailLayout>
}
